module.exports = __webpack_public_path__ + "img/flag_ja.47e3ac3f.svg";